module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div>\n    <label>\n        Кодировка\n        <select name=\"charset\" on-change=\"onCharsetChange\">\n            <option value=\"WINDOWS-1251\">WINDOWS-1251</option>\n            <option value=\"UTF-8\">UTF-8</option>\n        </select>\n    </label>\n</div>")
  }
  return __output.join("");

}